module.exports = window.webkitRequestAnimationFrame ||
window.mozRequestAnimationFrame ||
window.oRequestAnimationFrame ||
window.msRequestAnimationFrame ||
function(callback) {
	window.setTimeout(callback, 1000 / 60);
};


// WEBPACK FOOTER //
// ./src/lib/requestAnimationFrame.js